import { useMemo } from "react";
import { Condition } from "@app/projects/network-assessment/provider-hub/interfaces";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { useQuery } from "@tanstack/react-query";

export interface TopConditionsResult {
  data: DropdownItem<string>[];
  hasData: boolean;
  isError: boolean;
  isLoading: boolean;
}

export const TOP_CONDITIONS_QUERY_PREFIX = "provider-hub__top-conditions";

export const useTopConditions = (projectId: number | undefined, projectRunConfigurationId: number | undefined, enabled: boolean): TopConditionsResult => {
  const providerHubService = useMemo(() => new ProviderHubService(), []);

  const queryResult = useQuery<Condition[]>({
    enabled: enabled && !!projectId && !!projectRunConfigurationId,
    queryFn: async ({ signal }) => providerHubService.getTopConditions(projectId, projectRunConfigurationId, signal),
    queryKey: [TOP_CONDITIONS_QUERY_PREFIX, projectId, projectRunConfigurationId],
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: queryResult.data?.map(c => ({ key: c.code, name: `${c.code} - ${c.description}` })) ?? [],
    hasData: queryResult.isSuccess && queryResult.data?.length > 0,
    isError: queryResult.isError,
    isLoading: queryResult.isPending,
  };
}